export default __webpack_public_path__ + "static/media/H1016.2.4b7b03a0.mp3";